import { jsx as e } from "react/jsx-runtime";
import { IconAlertTriangle as t, IconArchive as n, IconCheck as r, IconInfoCircle as i, IconX as a } from "@tabler/icons-react";
// src/utils/confirmation.tsx
var o = {
	delete: {
		title: "Delete Item",
		message: "Are you sure you want to delete this item? This action cannot be undone.",
		color: "red",
		confirmText: "Delete",
		icon: /* @__PURE__ */ e(t, { size: 20 })
	},
	complete: {
		title: "Mark Complete",
		message: "Are you sure you want to mark this as complete?",
		color: "green",
		confirmText: "Complete",
		icon: /* @__PURE__ */ e(r, { size: 20 })
	},
	cancel: {
		title: "Cancel",
		message: "Are you sure you want to cancel? Any unsaved changes will be lost.",
		color: "orange",
		confirmText: "Yes, Cancel",
		icon: /* @__PURE__ */ e(a, { size: 20 })
	},
	navigate: {
		title: "Unsaved Changes",
		message: "You have unsaved changes. Are you sure you want to leave? Any unsaved changes will be lost.",
		color: "orange",
		confirmText: "Discard Changes",
		cancelText: "Keep Editing",
		icon: /* @__PURE__ */ e(t, { size: 20 })
	},
	archive: {
		title: "Archive Task",
		message: "Are you sure you want to archive this task? It will be removed from your active task list.",
		color: "gray",
		confirmText: "Archive",
		icon: /* @__PURE__ */ e(n, { size: 20 })
	},
	info: {
		title: "Information",
		message: "Please confirm this action.",
		color: "blue",
		confirmText: "Continue",
		icon: /* @__PURE__ */ e(i, { size: 20 })
	}
};
export { o as t };

//# sourceMappingURL=confirmation-Doy09wYN.js.map